import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';

import { embarcadoresAPI } from 'services/apiRest';
import EmbarcadoresActions from '../ducks/embarcadores';

export function* getEmbarcadores() {
  try {
    const embarcadores = yield call(embarcadoresAPI.listar);
    yield put(EmbarcadoresActions.getEmbarcadoresSuccess(embarcadores));
  } catch (err) {
    console.error('Erro ao buscar embarcadores:', err);
    yield put(EmbarcadoresActions.getEmbarcadoresFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao buscar embarcadores',
      })
    );
  }
}

export function* addEmbarcador({ embarcador, closeModal }) {
  try {
    const criado = yield call(embarcadoresAPI.criar, embarcador);
    yield put(EmbarcadoresActions.addEmbarcadorSuccess(criado));

    if (closeModal) closeModal();

    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Embarcador',
        message: 'Embarcador criado com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao criar embarcador:', err);
    yield put(EmbarcadoresActions.addEmbarcadorFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao criar embarcador',
      })
    );
  }
}

export function* updateEmbarcador({ embarcador, closeModal }) {
  try {
    const atualizado = yield call(embarcadoresAPI.atualizar, embarcador.id, embarcador);
    yield put(EmbarcadoresActions.updateEmbarcadorSuccess(atualizado));

    if (closeModal) closeModal();

    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Embarcador',
        message: 'Embarcador atualizado com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao atualizar embarcador:', err);
    yield put(EmbarcadoresActions.updateEmbarcadorFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao atualizar embarcador',
      })
    );
  }
}

export function* removeEmbarcador({ id }) {
  try {
    yield call(embarcadoresAPI.deletar, id);
    yield put(EmbarcadoresActions.removeEmbarcadorSuccess(id));
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Embarcador',
        message: 'Embarcador excluído com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao excluir embarcador:', err);
    yield put(EmbarcadoresActions.removeEmbarcadorFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao excluir embarcador',
      })
    );
  }
}


